import { useContext } from "react";
import GeneralPositionContext from "../contexts/GeneralPositionProvider";

const useGeneralPosition = () => {
  return useContext(GeneralPositionContext);
};

export default useGeneralPosition;
